export const IMAGE_SIZE_LIMIT = 15 * 1024 * 1024 // 50Mbs
export const DEFAULT_VIDEO_SIZE_LIMIT = 50

export const toBytes = sizeInMb => sizeInMb * 1024 * 1024

export const VIDEO_UPLOAD_STATUS = {
  PREPARING: "preparing",
  READY: "ready"
}
